import { render } from "./CreateCoupon.vue?vue&type=template&id=506fe73b&scoped=true"
import script from "./CreateCoupon.vue?vue&type=script&lang=js"
export * from "./CreateCoupon.vue?vue&type=script&lang=js"

import "./CreateCoupon.vue?vue&type=style&index=0&id=506fe73b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506fe73b"]])

export default __exports__